
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/create/userEvent",
      function () {
        return require("private-next-pages/create/userEvent.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/create/userEvent"])
      });
    }
  